import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { LegacyButton } from '@/components/LegacyButton';
import { NextImage } from '@/components/NextImage';
import { Typography } from '@/components/Typography';

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    color: ${theme.colors.default};
    font-size: ${theme.fontSizes.p2};
    text-align: center;
    background-color: ${theme.colors.primary};
    padding-right: 15px;
    padding-left: 15px;
    padding-top: 30px;
    padding-bottom: 30px;
    margin: 0 auto;
    margin-top: 30px;
    ${theme.media.md.up} {
      display: flex;
      justify-content: space-between;
      padding-left: 100px;
      padding-right: 100px;
      text-align: left;
      margin-top: 40px;
    }
  `}
`;
export const PaymentsBox = styled(Box)`
  flex-grow: 1;
`;
export const PaymentsHeader = styled(Typography)`
  ${({ theme }) => css`
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 15px;
    padding-left: 80px;
    padding-right: 80px;
    ${theme.media.md.up} {
      padding-left: 0;
      padding-right: 0;
      text-align: left;
  `}
`;
export const ShopBagCardsListWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 0;
`;
export const ShopBagCard = styled(Box)`
  text-align: center;
  max-width: 60px;
  padding: 0;
  width: 20%;
`;
export const ShopBagImage = styled(NextImage)``;
export const PaymentsSmallText = styled(Box)`
  margin-top: 10px;
  font-size: 12px;
`;
export const WhiteSpaceVertical = styled(Box)`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    height: 1px;
    margin: 24px auto;
    max-width: 200px;
    ${theme.media.md.up} {
      display: none;
    }
  `}
`;
export const ContactsBox = styled(Box)`
  ${({ theme }) => css`
    position: relative;
    ${theme.media.md.up} {
      padding-left: 60px;

      &:before {
        background: ${theme.colors.mediumGrey};
        content: '';
        display: block;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 1px;
      }
    }
  `}
`;
export const ContactsHeader = styled(Typography)`
  ${({ theme }) => css`
    margin-bottom: 15px;
    padding-left: 80px;
    padding-right: 80px;
    ${theme.media.md.up} {
      margin-bottom: 15px;
      padding-left: 0;
      padding-right: 0;
    }
  `}
`;
export const ContactsText = styled(Typography)`
  ${({ theme }) => css`
    text-align: center;
    ${theme.media.md.up} {
      text-align: left;
    }
  `}
`;
export const Cta = styled(LegacyButton)`
  ${({ theme }) => css`
    margin-top: 15px;
    max-width: none;
    width: 100%;
    text-decoration: none;
    ${theme.media.md.up} {
      width: auto;
    }
  `}
`;
